import * as React from 'react';

export default function ChildFriendly({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 15.8333 16.6094'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16667 0.842404V6.60907H15.8333C15.8333 3.25074 13.35 0.467404 10.1167 0.00907079C9.61667 -0.0659292 9.16667 0.334071 9.16667 0.842404ZM14.4333 11.5174C15.3083 10.3924 15.8333 8.97574 15.8333 7.4424H3.7L3.13333 6.25074C3 5.95907 2.7 5.77574 2.38333 5.77574H0.833333C0.375 5.77574 0 6.15074 0 6.60907C0 7.0674 0.375 7.4424 0.833333 7.4424H1.85C1.85 7.4424 3.425 10.8341 3.61667 11.1257C2.50833 11.7174 1.83333 13.0174 2.16667 14.4091C2.41667 15.4591 3.28333 16.3007 4.33333 16.5341C6.08333 16.9174 7.65 15.7341 7.875 14.1091H9.60833C9.83333 15.7257 11.3917 16.9091 13.125 16.5424C14.1833 16.3174 15.05 15.4841 15.3167 14.4341C15.6083 13.2757 15.2 12.2007 14.4333 11.5174ZM5 14.9424C4.30833 14.9424 3.75 14.3841 3.75 13.6924C3.75 13.0007 4.30833 12.4424 5 12.4424C5.69167 12.4424 6.25 13.0007 6.25 13.6924C6.25 14.3841 5.69167 14.9424 5 14.9424ZM12.5 14.9424C11.8083 14.9424 11.25 14.3841 11.25 13.6924C11.25 13.0007 11.8083 12.4424 12.5 12.4424C13.1917 12.4424 13.75 13.0007 13.75 13.6924C13.75 14.3841 13.1917 14.9424 12.5 14.9424Z"
        fill="currentColor"
      />
    </svg>
  );
}
